const S36_PlumuleScatter=[
    {
        "group": "S36P",
        "sample": "JNP9DAP1",
        "sample_group": "JNP9DAP",
        "PC1": -43.2302152851931,
        "PC2": -14.8291070117894
    },
    {
        "group": "S36P",
        "sample": "JNP9DAP2",
        "sample_group": "JNP9DAP",
        "PC1": -43.1210642235709,
        "PC2": -17.4287809878798
    },
    {
        "group": "S36P",
        "sample": "JNP9DAP3",
        "sample_group": "JNP9DAP",
        "PC1": -43.4959566411244,
        "PC2": -16.4658494213102
    },
    {
        "group": "S36P",
        "sample": "JNP12DAP1",
        "sample_group": "JNP12DAP",
        "PC1": -32.4239121426411,
        "PC2": 1.78729737480496
    },
    {
        "group": "S36P",
        "sample": "JNP12DAP2",
        "sample_group": "JNP12DAP",
        "PC1": -36.2922777320504,
        "PC2": -3.78675071928879
    },
    {
        "group": "S36P",
        "sample": "JNP12DAP3",
        "sample_group": "JNP12DAP",
        "PC1": -31.5703675376044,
        "PC2": 1.11832701758296
    },
    {
        "group": "S36P",
        "sample": "JNP15DAP1",
        "sample_group": "JNP15DAP",
        "PC1": 6.5209995796124,
        "PC2": 22.1453844561085
    },
    {
        "group": "S36P",
        "sample": "JNP15DAP2",
        "sample_group": "JNP15DAP",
        "PC1": -5.00790538096832,
        "PC2": 20.4771780515667
    },
    {
        "group": "S36P",
        "sample": "JNP15DAP3",
        "sample_group": "JNP15DAP",
        "PC1": 6.27045353992045,
        "PC2": 23.1563435366263
    },
    {
        "group": "S36P",
        "sample": "JNP18DAP1",
        "sample_group": "JNP18DAP",
        "PC1": 23.0527084647572,
        "PC2": 20.113965824192
    },
    {
        "group": "S36P",
        "sample": "JNP18DAP2",
        "sample_group": "JNP18DAP",
        "PC1": 28.2101947426312,
        "PC2": 17.406146782888
    },
    {
        "group": "S36P",
        "sample": "JNP18DAP3",
        "sample_group": "JNP18DAP",
        "PC1": 21.1314205934547,
        "PC2": 21.1936588747224
    },
    {
        "group": "S36P",
        "sample": "JNP24DAP1",
        "sample_group": "JNP24DAP",
        "PC1": 50.2496759175838,
        "PC2": -23.8831789645745
    },
    {
        "group": "S36P",
        "sample": "JNP24DAP2",
        "sample_group": "JNP24DAP",
        "PC1": 50.3441754547177,
        "PC2": -25.2463334000689
    },
    {
        "group": "S36P",
        "sample": "JNP24DAP3",
        "sample_group": "JNP24DAP",
        "PC1": 49.3620706504752,
        "PC2": -25.7583014135803
    }
]
const groupedDataS36Plu = S36_PlumuleScatter.reduce((acc, curr) => {
    // 如果 group 不存在，初始化为一个空数组
    if (!acc[curr.sample_group]) {
        acc[curr.sample_group] = [];
    }
    // 将当前的对象添加到对应 sample_group 的数组中
    acc[curr.sample_group].push(curr);
    return acc;
}, {});
export default groupedDataS36Plu